import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { DomainSetupResult } from "@shared/praxis-admin";

const statusClassNames: Record<DomainSetupResult["status"], string> = {
  done: "border-green-200 bg-green-50 text-green-900",
  pending: "border-orange-200 bg-orange-50 text-orange-900",
  failed: "border-red-200 bg-red-50 text-red-900",
  disabled: "border-gray-200 bg-gray-50 text-gray-800",
};

const RecordList: React.FC<{ title: string; records: string[] }> = ({
  title,
  records,
}) =>
  records.length ? (
    <div>
      <div className="font-semibold">{title}</div>
      <ul className="ml-4 list-disc break-all font-mono text-xs">
        {records.map((record) => (
          <li key={record}>{record}</li>
        ))}
      </ul>
    </div>
  ) : null;

export const DomainSetupResultView: React.FC<{ result: DomainSetupResult }> = ({
  result,
}) => {
  const { t } = useTranslation();

  return (
    <div
      role="status"
      className={classNames(
        "flex flex-col gap-2 rounded-lg border p-3 text-sm",
        statusClassNames[result.status],
      )}
    >
      <div className="font-semibold">
        {t(`admin.domainSetup.status.${result.status}`, {
          domain: result.domain,
        })}
      </div>
      {result.status === "pending" && <div>{result.message}</div>}
      {result.status === "failed" && (
        <div className="break-words">{result.error}</div>
      )}
      {result.status === "done" && (
        <>
          <RecordList
            title={t("admin.domainSetup.createdRecords")}
            records={result.createdRecords}
          />
          <RecordList
            title={t("admin.domainSetup.existingRecords")}
            records={result.existingRecords}
          />
          <RecordList
            title={t("admin.domainSetup.recordsToRemoveManually")}
            records={result.recordsToRemoveManually}
          />
        </>
      )}
    </div>
  );
};
